import { Badge, Flex, Text } from '@mantine/core';
import type { CandidateReview } from '@entities/candidateReview';
import { formatRatingValue } from '@shared/utils';
import { ReviewAnswersList } from '../components';
import classes from './ReviewDetailModalContent.module.scss';

type CandidateReviewDetailModalContentProps = {
  review: CandidateReview;
};

export const CandidateReviewDetailModalContent = ({
  review,
}: CandidateReviewDetailModalContentProps) => {
  const candidateName = [
    review.candidate?.lastname,
    review.candidate?.firstname,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <Flex direction='column' gap={24}>
      <Flex direction='column' gap={16}>
        <Flex justify='space-between' align='center' gap={16}>
          <Text c='tertiary.7' size='sm'>
            {review.vacancy.name}
          </Text>
          {review.ratingTotal != null && (
            <Flex className={classes.ratingBadge}>
              <Text size='xl' c='white'>
                {formatRatingValue(review.ratingTotal)}
              </Text>
            </Flex>
          )}
        </Flex>

        {candidateName && (
          <Text size='sm' fw={600}>
            {candidateName}
          </Text>
        )}

        <Flex direction='column' gap={8} className={classes.reviewInfo}>
          <Text size='sm' c='tertiary.7'>
            {review.company.name}
          </Text>
          <Flex gap={8} wrap='wrap'>
            {review.isHired === true && (
              <Badge variant='light' color='green' size='sm'>
                Был нанят
              </Badge>
            )}
            {review.isHired === false && (
              <Badge variant='light' color='red' size='sm'>
                Не был нанят
              </Badge>
            )}
            {review.interviewDone === true && (
              <Badge variant='light' color='green' size='sm'>
                Собеседование состоялось
              </Badge>
            )}
            {review.interviewDone === false && (
              <Badge variant='light' color='red' size='sm'>
                Собеседование не состоялось
              </Badge>
            )}
          </Flex>
        </Flex>

        {review.interviewDone === false &&
          review.interviewCancellationReason?.name && (
            <Flex direction='column' gap={8}>
              <Text size='sm' c='tertiary.9' fw={600}>
                Причина несостоявшегося собеседования
              </Text>
              <Text size='sm' c='tertiary.9'>
                {review.interviewCancellationReason.name}
              </Text>
            </Flex>
          )}

        {review.isHired === true && (
          <ReviewAnswersList answers={review.answers ?? []} />
        )}

        {review.isHired === false &&
          (review.rejectionReasons?.length ?? 0) > 0 && (
            <Flex direction='column' gap={8}>
              <Text size='sm' c='tertiary.9' fw={600}>
                Причина отказа
              </Text>
              {review.rejectionReasons?.map(reason => (
                <Text key={reason.id} size='sm' c='tertiary.9'>
                  {reason.name}
                </Text>
              ))}
            </Flex>
          )}
      </Flex>

      {review.comment && (
        <Flex direction='column' gap={8}>
          <Text size='sm' c='tertiary.9' fw={600}>
            Комментарий
          </Text>
          <Text size='sm' c='tertiary.9'>
            {review.comment}
          </Text>
        </Flex>
      )}
    </Flex>
  );
};
